import { useOutletContext } from 'react-router-dom';
import type { AdminMetrics, Booth, AdminUser } from '../../lib/api';

export interface AdminContextType {
  adminKey: string;
  currentUser: AdminUser | null;
  metrics?: AdminMetrics;
  booths: Booth[];
  attendees: any[];
  systemHealth?: any;
  isMetricsLoading: boolean;
  isBoothsLoading: boolean;
  isMetricsError: boolean;
  metricsError: unknown;
  refetchMetrics: () => void;
  refetchBooths: () => void;
  refetchAttendees?: () => void;
  refetchSystemHealth?: () => void;
  handleExportCsv: () => Promise<void>;
  isExporting: boolean;
  forceReleaseMutation: any;
  actionSuccessMessage: string | null;
  setActionSuccessMessage: (msg: string | null) => void;
  handleLogout: () => Promise<void>;
}

export function useAdminContext() {
  return useOutletContext<AdminContextType>();
}
